<template>
    <el-dialog :visible.sync="visible" :append-to-body="true" width="600px" :before-close="handleClose"
               :show-close="false"
               class="addKnowledgeWrapper">
        <div class="top" slot="title">
            <h3>加入知识单</h3>
            <a href="javascript:void(0)" slot="title" @click="visibleUpload = true">+新建知识单</a>
        </div>

        <el-form ref="markKnowledgeFrom" :model="formData" label-width="100px" :inline="true">
            <el-form-item label="已有知识单：">
                <div class="knowledgeList">
                    <el-radio v-model="formData.groupID" v-for="item in OwnKnowledgeList" :key="item.groupID"
                              :label="item.groupID">
                        {{ item.groupName }}
                    </el-radio>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="saveKnowledge">提 交</el-button>
        </div>
        <add-knowledge :visible="visibleUpload" @close="visibleUpload = false" @uploadSuccess="uploadSuccess"/>
    </el-dialog>
</template>
<script>
  import { ownknowledge, joinKnowledge } from '@/api/resourceDetail';
  import { addKnowledgeApi } from '@/api/knowledge';
  import addKnowledge from '@/components/Knowledge/addKnowledge';
  import { $Cookies } from '@/utils';

  export default {
    name: 'AddKnowledgePart',
    components: {
      addKnowledge
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      partsId: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        formData: {
          groupID: ''
        },
        visibleUpload: false,
        OwnKnowledgeList: [],
        newRules: {
          name: [
            { required: true, message: '请输入知识单名称', trigger: 'blur' }
          ]
        }
      };
    },
    async mounted () {
      await this.getOwnKnowledgeList();
    },
    methods: {
      getOwnKnowledgeList () {
        const uid = $Cookies.get('uid');
        ownknowledge(Number(uid)).then(data => {
          if (data.success) {
            this.OwnKnowledgeList = data.result.list;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      handleClose () {
        this.$emit('close');
      },
      uploadSuccess (data) {
        const uid = $Cookies.get('uid');
        let params = {
          userNo: Number(uid),
          ...data
        };
        addKnowledgeApi(params).then(data => {
          if (data.success) {
            this.$message({
              type: 'success',
              message: '新增知识单成功',
              duration:1000,
              onClose: () => {
                this.visibleUpload = false;
                this.getOwnKnowledgeList();
              }
            });
          } else {
            this.$message({
              type: 'error',
              message: '新增知识单失败',
              duration:1000,
              onClose: () => {
                this.visibleUpload = false;
              }
            });
          }
        });
      },
      saveKnowledge () {
        const uid = $Cookies.get('uid');
        const param = {
          userNo: Number(uid),
          groupID: this.formData.groupID,
          partID: this.partsId
        };
        joinKnowledge(param).then(data => {
          if (data.success) {
            this.$message({
              type: 'success',
              message: '添加成功！',
              duration:1000,
              onClose: () => {
                this.$emit('addSuccess');
                this.formData.groupID = '';
              }
            });
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      }
    }
  };
</script>
<style lang="scss">
    .addKnowledgeWrapper {
        .el-dialog__body {
            padding-top: 0;

            .el-form-item__content {
                margin-top: 10px;
                width: calc(100% - 100px)
            }
        }

        .knowledgeList {
            max-height: 230px;
            width: 450px;
            overflow: hidden;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background-color: #c9c9c9;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #3da6ff;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
            }

            label.el-radio {
                display: block;
                height: 30px;
                line-height: 30px;
                margin-left: 20px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/assets/css/mixins.scss";

    .addKnowledgeWrapper {
        .top {
            @include clearfix;

            h3 {
                font-size: 16px;
                border-bottom: 2px solid #1082ff;
                padding: 0 5px;
                @include fl;
            }

            a {
                font-size: 14px;
                color: #1082ff;
                @include fr;
                margin-top: 5px;
            }
        }

    }
</style>
